<template>
  <div>
    <table>
      <tr>
        <th></th>
        <th>Pays</th>
        <th>Ville</th>
        <th>Region</th>
        <th>IP</th>
        <th>Hostname</th>
        <th>Provider</th>
      </tr>
      <tr>
        <td>
          <strong>Infos Profil</strong>
        </td>
        <td>{{ prf.city.country.name }}</td>
        <td>{{ prf.city.name }} ({{ prf.city.zip }})</td>
        <td>{{ prf.city.department.region.name }}</td>
        <td>{{ usr.lastIp }}</td>
      </tr>
      <tr v-if="sniped && sniped.sniper">
        <td>
          <strong>Infos IP</strong>
        </td>
        <td>{{ sniped.sniper.country }}</td>
        <td>{{ sniped.sniper.city }}</td>
        <td>{{ sniped.sniper.state }} ({{ sniped.sniper.areacode }})</td>
        <td>{{ sniped.sniper.ipaddress }}</td>
        <td>{{ sniped.sniper.hostname }}</td>
        <td>{{ sniped.sniper.provider }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: ["prf", "usr", "sniped"]
};
</script>

<style scoped>
h3 {
  margin-top: 0;
  font-weight: normal;
  font-style: italic;
  font-size: 16px;
}

table,
th,
td {
  border: 1px solid;
  border-collapse: collapse;
  font-size: 14px;
}

th,
td {
  padding: 5px;
}
</style>
